import React from 'react'
import { Row, Col, Typography, Tooltip } from 'antd';
import { getfilteredCountries } from '../../../utils/Constants';
import { FaInfoCircle } from 'react-icons/fa';
import moment from 'moment';

const { Title } = Typography;

const TravellerDetailsTripjack = ({
    selectPayloadData,
    flightDetails,
    applyDiscountShow,
    applicableChargeData,
    calculatedFee,
    finalTotal,
    discountAmountOffer

}) => {


    const { travellerInfo } = selectPayloadData || {};

    const getTagColor = (paxType) => {
        switch (paxType) {
            case 1:
                return 'blue';
            case 2:
                return 'orange';
            case 3:
                return 'green';
            default:
                return 'gray';
        }
    };

    const getCountryNameByCode = (code) => {
        const country = getfilteredCountries.find(country => country.code === code);
        return country ? country.name : 'Unknown';
    };

    return (
        <div className="booking-details lastBorder">
            <div title="" className="traveller-card">
                <Title level={5} className='mt-3 mt-0'>Review Details</Title>
                <p className='mb-3'>Please ensure that the spelling of your name and other details match with your travel document/govt. ID, as these cannot be changed later. Errors might lead to cancellation penalties.</p>
                <Row gutter={16} style={{ overflow: 'auto', maxHeight: '420px', padding: '5px 0' }}>
                    {travellerInfo?.map((traveller, index) => (
                        <Col key={index} xs={24} sm={24} lg={24}>
                            <div className="card traveller-info-card">
                                <div className='card-header py-2'>
                                    <h3 style={{ color: getTagColor(traveller.pt) }}>
                                        <b>{traveller.pt === 1 ? 'ADULT' : traveller.pt === 2 ? 'CHILD' : 'INFANT'}</b>
                                    </h3>
                                    <p>Traveller {index + 1}</p>
                                </div>
                                <div className='card-body'>
                                    <p className="d-flex align-items-center justify-content-between border-bottom mb-1 pb-1">
                                        <span>Title:</span> <strong>{traveller?.ti || 'N/A'}</strong>
                                    </p>
                                    <p className='d-flex align-items-center justify-content-between border-bottom mb-1 pb-1'><span>First Name :</span> <strong>{traveller?.fN}</strong></p>
                                    <p className='d-flex align-items-center justify-content-between border-bottom mb-1 pb-1'><span>Last Name :</span> <strong>{traveller?.lN}</strong></p>
                                    {traveller?.dob && <p className='d-flex align-items-center justify-content-between border-bottom mb-1 pb-1'><span>Date of Birth :</span> <strong>{moment(traveller?.dob).format("MMM DD, YYYY")}</strong></p>}
                                    {traveller?.pNum && <p className='d-flex align-items-center justify-content-between border-bottom mb-1 pb-1'><span>Passport Number :</span> <strong>{traveller?.pNum}</strong></p>}
                                    {traveller?.pNat && <p className='d-flex align-items-center justify-content-between border-bottom mb-1 pb-1'><span>Nationality :</span> <strong>{getCountryNameByCode(traveller?.pNat)}</strong></p>}
                                    {traveller?.pid && <p className='d-flex align-items-center justify-content-between border-bottom mb-1 pb-1'><span>Passport Issuing  Date :</span> <strong>{moment(traveller?.pid).format("MMM DD, YYYY")}</strong></p>}
                                    {traveller?.eD && <p className='d-flex align-items-center justify-content-between'><span>Passport Expiry Date :</span> <strong>{moment(traveller?.eD).format("MMM DD, YYYY")}</strong></p>}
                                </div></div>
                        </Col>
                    ))}
                </Row>
            </div>

            {(!flightDetails?.tripInfos?.[0]?.sI?.[0]?.ssrInfo?.MEAL?.length &&
                !flightDetails?.tripInfos?.[0]?.sI?.[0]?.ssrInfo?.BAGGAGE?.length)
                &&
                <div title="" className="traveller-card">
                    <Row gutter={16} style={{ overflowY: 'auto', maxHeight: '420px', padding: '5px 0' }}>
                        <Col xs={24}>
                            <div className="card traveller-info-card">
                                <div className="card-body">

                                    {flightDetails?.searchQuery?.paxInfo?.ADULT > 0 && (
                                        <li className="d-flex justify-content-between border-bottom mb-1 pb-1">
                                            <div> <span>{flightDetails.searchQuery.paxInfo.ADULT === 1 ? "Adult" : "Adults"} </span>({flightDetails.searchQuery.paxInfo.ADULT} X ₹{flightDetails?.priceBreakup?.ADULT_BF || 0})</div>
                                            <span><strong>₹{(flightDetails?.priceBreakup?.ADULT_BF || 0) * flightDetails.searchQuery.paxInfo.ADULT}</strong></span>
                                        </li>
                                    )}

                                    {flightDetails?.searchQuery?.paxInfo?.CHILD > 0 && (
                                        <li className="d-flex justify-content-between border-bottom mb-1 pb-1">
                                            <div><span>{flightDetails.searchQuery.paxInfo.CHILD === 1 ? "Child" : "Children"}</span> ({flightDetails.searchQuery.paxInfo.CHILD} X ₹{flightDetails?.priceBreakup?.CHILD_BF || 0})</div>
                                            <span><strong>₹{(flightDetails?.priceBreakup?.CHILD_BF || 0) * flightDetails.searchQuery.paxInfo.CHILD}</strong></span>
                                        </li>
                                    )}

                                    {flightDetails?.searchQuery?.paxInfo?.INFANT > 0 && (
                                        <li className="d-flex justify-content-between border-bottom mb-1 pb-1">
                                            <div><span>{flightDetails.searchQuery.paxInfo.CHILD === 1 ? "Infant" : "Infants"} </span>({flightDetails.searchQuery.paxInfo.INFANT} X ₹{flightDetails?.priceBreakup?.INFANT_BF || 0})</div>
                                            <span><strong> ₹{(flightDetails?.priceBreakup?.INFANT_BF || 0) * flightDetails.searchQuery.paxInfo.INFANT}</strong></span>
                                        </li>
                                    )}

                                    <p className="d-flex align-items-center justify-content-between border-bottom mb-1 pb-1">
                                        <span> Tax & Surcharges:</span> <strong>₹ {Math.round(flightDetails?.priceBreakup?.ServiceTax)}</strong>
                                    </p>

                                    <p className="d-flex align-items-center justify-content-between border-bottom mb-1 pb-1">
                                        <span className='d-flex justify-content-between align-items-center'>
                                            Other
                                            <Tooltip title={`${applicableChargeData?.title}`}>
                                                <FaInfoCircle className="mx-1" />
                                            </Tooltip>{""}
                                            :
                                        </span>
                                        <strong>₹ {Math.round(calculatedFee)}</strong>
                                    </p>

                                    {applyDiscountShow && discountAmountOffer > 0 && (
                                        <p className="d-flex align-items-center justify-content-between border-bottom mb-1 pb-1">
                                            <span className='d-flex justify-content-between align-items-center'> Discount :</span>
                                            <strong className='text-danger'>₹ {Math.round(discountAmountOffer)}</strong>
                                        </p>
                                    )}

                                    <p className="d-flex align-items-center justify-content-between border-bottom mb-1 pb-1">
                                        <span>Total :</span> <strong>₹{Math.round(finalTotal - Number(discountAmountOffer))}</strong>
                                    </p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            }



        </div>
    )
}

export default TravellerDetailsTripjack